export const PHONE_INPUT = {
  defaultCountry: "IN",
  locale: "en",
  maxLength: 24,
} as const;
